var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElectricCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_863_5528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.92 2.01098C18.72 1.42098 18.16 1.00098 17.5 1.00098H6.5C5.84 1.00098 5.29 1.42098 5.08 2.01098L3 8.00098V16.001C3 16.551 3.45 17.001 4 17.001H5C5.55 17.001 6 16.551 6 16.001V15.001H18V16.001C18 16.551 18.45 17.001 19 17.001H20C20.55 17.001 21 16.551 21 16.001V8.00098L18.92 2.01098ZM6.5 12.001C5.67 12.001 5 11.331 5 10.501C5 9.67098 5.67 9.00098 6.5 9.00098C7.33 9.00098 8 9.67098 8 10.501C8 11.331 7.33 12.001 6.5 12.001ZM17.5 12.001C16.67 12.001 16 11.331 16 10.501C16 9.67098 16.67 9.00098 17.5 9.00098C18.33 9.00098 19 9.67098 19 10.501C19 11.331 18.33 12.001 17.5 12.001ZM5 7.00098L6.5 2.50098H17.5L19 7.00098H5Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00024 20H11.0002V18L17.0002 21H13.0002V23L7.00024 20Z",
    fill: "#2E2E2E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_863_5528"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricCar);
export default __webpack_public_path__ + "static/media/electricCar.2aef5b305efd9353d1729b5d5295e91c.svg";
export { ForwardRef as ReactComponent };